import { ArticleStatus } from 'hooks/article'

const STYLES: Record<ArticleStatus, string> = {
    draft: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
    in_review: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200',
    changes_requested: 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-200',
    approved: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200',
    published: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200',
    archived: 'bg-gray-200 text-gray-700 dark:bg-slate-700 dark:text-slate-200',
}

export const ARTICLE_STATUS_LABELS: Record<ArticleStatus, string> = {
    draft: 'Draft',
    in_review: 'In review',
    changes_requested: 'Changes requested',
    approved: 'Approved',
    published: 'Published',
    archived: 'Archived',
}

const ArticleStatusBadge = ({ status }: { status?: ArticleStatus | string | null }) => {
    const key = (status as ArticleStatus) in STYLES ? (status as ArticleStatus) : 'draft'
    return (
        <span
            className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${STYLES[key]}`}
        >
            {ARTICLE_STATUS_LABELS[key]}
        </span>
    )
}

export default ArticleStatusBadge